import * as React from 'react';
import EditBookCard, { EditCardProps } from '../EditBookCard/EditBookCard';
import Dialog from '@material-ui/core/Dialog';
import { useMediaQuery } from 'react-responsive';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from "@material-ui/icons/Close";

type Props = EditCardProps & {
	open: boolean;
	onClose: () => void;
}

const PopupEditBookCard: React.FC<Props> = props => {
	const { open, onClose, ...editBookProps } = props;

	const isMobile = useMediaQuery({ maxWidth: 600 });

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="lg"
			fullScreen={isMobile}
			classes={{
				paper: "book-calendar-dialogCard__paper",
			}}
		>
			{isMobile && (
				<div className="book-calendar-dialogCard-toolbar">
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>

					<div className="book-calendar-dialogCard-toolbar__header">
						Изменить
					</div>
				</div>
			)}

			<EditBookCard {...editBookProps} onClose={props.onClose}/>
		</Dialog>
	);
};

export default PopupEditBookCard;
